import gdiRewardStatusSectionBlock from './my-rewards/gdiRewardStatusSectionBlock'
import gdiRewardTileBlock from './my-rewards/gdiRewardTileBlock'
import gdiRewardTierTableBlock from './my-rewards/gdiRewardTierTableBlock'

export default {
    parts: [],
    baseStyle: () => ({
        ...gdiRewardStatusSectionBlock,
        ...gdiRewardTileBlock,
        ...gdiRewardTierTableBlock
    })
}
